export default {"src":"/_next/static/media/organize-team-registrations.7311513d.svg","height":125,"width":140,"blurWidth":0,"blurHeight":0};